import React, { useState } from "react";
import * as actions from "./store/billingPlanActions";
import { connect } from "react-redux";
import { Paper, Step, StepLabel, Stepper, withStyles } from "@material-ui/core";
import { BackButton } from "../../sc-utilities";
import History from "../../../History";
import PlanForm from "./PlanForm";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(1),
        margin: theme.spacing(1)
    },
    submit: {
        width: '120px',
        marginTop: '10px',
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
    cancel: {
        width: '120px',
        marginTop: '10px',
        marginRight: '10px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
    formControl: {
        width: '100%'
    },
    datePicker: {
        width: '100%'
    }
});

const PlanCreate = (props) => {
    const { activeCustomerID, translations, classes, onCreateBillingPlan, cancelHandler, handleBack, handleNext, permissions } = props;
    const [activeStep, setActiveStep] = useState(0);
    const steps = [translations["create_plan"] || 'Create plan', translations["configuration"] || 'Configuration', translations["price_list"] || 'Price list'];

    const submitHandler = async data => {
        let requestData = { ...data };

        const config = !(requestData?.PostpaidAllowed && !requestData?.PrepaidAllowed) ?
            {
                MaxAllowedUsers: requestData.MaxAllowedUsers,
                MaxRemoteDiskNumber: requestData.MaxRemoteDiskNumber,
                ErasureRedemptionPeriod: requestData.ErasureRedemptionPeriod,
                DiagnoseRedemptionPeriod: requestData.DiagnoseRedemptionPeriod,
                CheckRedemptionPeriod: requestData.CheckRedemptionPeriod,
                VerificationRedemptionPeriod: requestData.VerificationRedemptionPeriod,
                AppleFullCheckPrice: requestData.AppleFullCheckPrice,
                AppleSimlockCheckPrice: requestData.AppleSimlockCheckPrice,
                GsmaCheckPrice: requestData.GsmaCheckPrice,
                SamsungWorldwideCheckPrice: requestData.SamsungWorldwideCheckPrice,
                MdmWorkCheckPrice: requestData.MdmWorkCheckPrice,
                AppleICloudLockCheckPrice: requestData.AppleICloudLockCheckPrice,
                AutopilotCheckPrice: requestData.AutopilotCheckPrice,
            } : {
                MonthlyPrice: requestData.MonthlyPrice,
                ErasureRedemptionPeriod: requestData.ErasureRedemptionPeriod,
                DiagnoseRedemptionPeriod: requestData.DiagnoseRedemptionPeriod,
                CheckRedemptionPeriod: requestData.CheckRedemptionPeriod,
                VerificationRedemptionPeriod: requestData.VerificationRedemptionPeriod,
                MaxAllowedUsers: requestData.MaxAllowedUsers,
                AllowedOveruse: requestData.AllowedOveruse,
                IncludedUsage: requestData.IncludedUsage,
                MinimalUsage: requestData.MinimalUsage,
                MaxRemoteDiskNumber: requestData.MaxRemoteDiskNumber,
                AppleFullCheckPrice: requestData.AppleFullCheckPrice,
                AppleSimlockCheckPrice: requestData.AppleSimlockCheckPrice,
                GsmaCheckPrice: requestData.GsmaCheckPrice,
                SamsungWorldwideCheckPrice: requestData.SamsungWorldwideCheckPrice,
                MdmWorkCheckPrice: requestData.MdmWorkCheckPrice,
                AppleICloudLockCheckPrice: requestData.AppleICloudLockCheckPrice,
                AutopilotCheckPrice: requestData.AutopilotCheckPrice,
            };

        const priceData = {
            mobile: requestData['Mobile Erasure'],
            mobile_erasure_lite: requestData['Mobile Erasure Lite'],
            mobile_verifier: requestData['Mobile Erasure Verification'],
            mobile_diagnose: requestData['Mobile Diagnose'],
            mobile_check: requestData['Mobile Check'],
            work: requestData['Work Erasure'],
            work_verifier: requestData['Work Erasure Verification'],
            work_diagnose: requestData['Work Diagnose'],
            work_check: requestData['Work Check'],
            watch: requestData['Watch Erasure'],
            watch_diagnose: requestData['Watch Diagnose'],
            watch_check: requestData['Watch Check'],
            headphone_diagnose: requestData['Headphone Diagnose'],
            headphone_check: requestData['Headphone Check'],
            remote: requestData.Remote
        };
        const details = {
            Name: requestData?.Name,
            Description: requestData?.Description,
            Status: requestData?.Status,
            ValidFrom: requestData?.ValidFrom,
            ValidTo: requestData?.ValidTo,
            PostpaidAllowed: requestData?.PostpaidAllowed,
            PrepaidAllowed: requestData?.PrepaidAllowed,
        };

        await onCreateBillingPlan({ ...details, PriceList: JSON.stringify(priceData), Configuration: JSON.stringify(config), ActiveCustomerID: activeCustomerID });

        setActiveStep(0);
        History.goBack()
    }

    return (
        <Paper className={classes.root}>
            {BackButton(translations, classes.customTooltip)}
            <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map((label) => {
                    return (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
            <PlanForm permissions={permissions} activeStep={activeStep} setActiveStep={setActiveStep} translations={translations} submitHandler={submitHandler} cancelHandler={cancelHandler} handleBack={handleBack} handleNext={handleNext} />
        </Paper>
    )
}

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state?.translate?.translations?.activeTranslations || {},
        creating: state.billing.plans.creating,
        permissions: state?.core?.login?.permissions || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCreateBillingPlan: billingPlan => dispatch(actions.createBillingPlan(billingPlan)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PlanCreate));